import { render } from "./HeaderFragment.vue?vue&type=template&id=12a328df&scoped=true"
import script from "./HeaderFragment.vue?vue&type=script&lang=js"
export * from "./HeaderFragment.vue?vue&type=script&lang=js"

import "./HeaderFragment.vue?vue&type=style&index=0&id=12a328df&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a328df"]])

export default __exports__